Component.register('components/serial-compare.vue');

$(document).ready(function() {
    // Serial compare
    $('.product-card__serial-compare').on('click', function(e) {
        e.preventDefault();
        const data = $(this).data();
        Component
            .load('serial-compare')
            .created(() => {
                events.relay({
                    name: 'serialCompareShow',
                    args: {
                        status: true,
                        source: '/webservices_sw/items/detail/'+ data.itemid +'?format=serialcompare&serial=' + data.serial,
                        currentSerial: data.serial,
                    },
                });
            });
    });

    $('.product-card__serial-compare').on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const data = $(this).data();
            const trigger = document.activeElement;
            Component
            .load('serial-compare')
            .created(() => {
                events.relay({
                    name: 'serialCompareShow',
                    args: {
                        status: true,
                        source: '/webservices_sw/items/detail/'+ data.itemid +'?format=serialcompare&serial=' + data.serial,
                        currentSerial: data.serial,
                        trigger,
                    },
                });
            })
        };
    });
});

// It is called from the public/store/category.php line 2295
new Vue({
    el: '#store-category',
});
